// extracted by mini-css-extract-plugin
export var errorsContainer = "_tp-1";
export var link = "_tp-0";